import React from 'react'

const Footer = () => {
  return (
    <div>
      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright <strong><span>CRM</span></strong>. All Rights Reserved
        </div>
        <div className="credits">

          Designed by <a href="https://bootstrapmade.com/">Real Do</a>
        </div>
      </footer>
    </div>
  )
}

export default Footer
